import { DetailsResolver } from '@core/resolvers';
import { HttpService } from '@core/services';
import { EquipmentHttpService, LeasingHttpService } from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';

export class LeasingDetailsResolver extends DetailsResolver {
  async resolve(): Promise<void> {
    await super.resolve();

    const [projectBundleID] = getProjectBundleIDParamFromUrl();

    await Promise.all([
      HttpService.getHttpRequests(LeasingHttpService).getLeasingSummaryData(
        projectBundleID,
      ),
      HttpService.getHttpRequests(EquipmentHttpService).getEquipmentTypes(),
    ]);
  }
}
